import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GenericService } from '@services/generic.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'search-panel',
  templateUrl: './search-panel.component.html',
  styleUrls: ['./search-panel.component.scss'],
})
export class SearchPanelComponent {
  @Input() public header: string;
  @Input() public open: boolean = false;
  @Input() public showExcel: boolean = true;
  @Input() public showBatchExport: boolean = false;
  @Input() public showPrint: boolean = false;
  @Input() public excelDisabled: boolean = false;
  @Input() public printDisabled: boolean = false;
  @Input() public showClearAll: boolean = true;
  @Input() public disableSearch: boolean = false;
  @Input() public submitZoneClass: string = 'col-12';
  @Output() public openChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() public submitForm: EventEmitter<any> = new EventEmitter<any>();
  @Output() public clearFilters: EventEmitter<any> = new EventEmitter<any>();
  @Output() public exportAsExcel: EventEmitter<any> = new EventEmitter<any>();
  @Output() public exportBatch: EventEmitter<any> = new EventEmitter<any>();
  @Output() public print: EventEmitter<any> = new EventEmitter<any>();

  public isTablet$: Observable<boolean>;

  constructor(private genericService: GenericService) {
    this.isTablet$ = this.genericService.isTablet$;
  }

  public onSubmit(): void {
    this.submitForm.emit();
  }

  public onClearFilters(): void {
    this.clearFilters.emit();
  }

  public toggleOpen(): void {
    this.openChange.emit(!this.open);
  }

  public onPrint() {
    this.print.emit();
  }

  public onBatchExport() {
    this.exportBatch.emit();
  }
}
